import { ModalWrapper, ButtonBase } from "@repo/ui/index.tsx";

type TConfirmModal = {
  infoText?: string;
  title?: string;
  description?: string;
  text?: string;
  isOpen: boolean;
  bgColor?: string;
  buttonType?: "primary" | "secondary" | "tertiary";
  handleCloseModal: () => void;
  handleDelete?: () => void;
  handleUpdate?: () => void;
  isLoading: boolean;
  cancelBtnText?: string;
  className?: string;
};
const ConfirmModal: React.FC<TConfirmModal> = ({
  infoText = "This action cannot be undone!",
  text,
  isOpen,
  isLoading,
  bgColor,
  title,
  description,
  buttonType,
  handleCloseModal,
  handleDelete,
  handleUpdate,
  cancelBtnText = "Cancel",
  className = "w-96",
}) => {
  return (
    <ModalWrapper
      isOpen={isOpen}
      handleCloseModal={handleCloseModal}
      containerClass="w-96"
      title={` ${title ? title : "Confirm delete"}`}
      description={description}
    >
      <div className={`flex flex-col gap-3 ${className}`}>
        <div className=" w-full px-2 flex items-center bg-opacity-30 bg-extraLightGray rounded-md py-2">
          <p className="text-sm font-bold">{infoText}</p>
        </div>

        <div className="flex gap-2">
          <ButtonBase
            type="button"
            buttonType="secondary"
            text={cancelBtnText}
            className="h-9 w-full text-body"
            onClick={handleCloseModal}
          />

          <ButtonBase
            text={`${text ? text : "Delete"}`}
            isLoading={isLoading}
            buttonType={buttonType || "tertiary"}
            type="submit"
            className={`h-9 text-white w-full ${
              bgColor ? bgColor : "bg-error"
            }`}
            onClick={handleDelete || handleUpdate}
          />
        </div>
      </div>
    </ModalWrapper>
  );
};

export default ConfirmModal;
